var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.start)?_c('Navigation'):_vm._e(),(_vm.start)?_c('v-main',{staticClass:"wrapper main"},[_c('router-view')],1):_vm._e(),(_vm.start)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }